import LandTransferPage from './LandTransferPage.container'
export default LandTransferPage
